import { Dispatch, SetStateAction, useCallback } from "react"
import { Chip } from "@mui/material"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { ResourceFiltersTypes } from "../../../createOrderTypes"

import { useFilterChipStyles } from "./filterChipStyles"

type MeetingAvailabilityFilterProps = Readonly<{
    isActive: boolean
    setFilters: Dispatch<SetStateAction<ResourceFiltersTypes>>
}>

export function MeetingAvailabilityFilter({ isActive, setFilters }: MeetingAvailabilityFilterProps) {
    const { classes, cx } = useFilterChipStyles()

    const setActive = useCallback(
        (onlyAvailableForMeeting: boolean) => setFilters((prev) => ({ ...prev, onlyAvailableForMeeting })),
        [setFilters],
    )

    return (
        <LocalizedStrict id="create-order-timeline-meeting-availability-filter" attrs={{ label: true }}>
            <Chip
                label="Available for the meeting"
                onClick={!isActive ? () => setActive(true) : undefined}
                onDelete={isActive ? () => setActive(false) : undefined}
                className={cx(classes.chip, isActive ? classes.selectedChip : classes.unselectedChip)}
            />
        </LocalizedStrict>
    )
}
